export default "__VITE_ASSET__2e45e03f__"